module.exports = __webpack_public_path__ + "static/media/sandwich-set.c32452b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/sandwich-set.jpg
// module id = 215
// module chunks = 0